import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import InputMask from 'react-input-mask';

const LicensePlateInput = ({ label, name, register, setValue, errors, rules = {}, placeholder = "Digite a placa", value = '', userRoles }) => {
  const [mask, setMask] = useState('');

  useEffect(() => {
    const numericValue = value.replace(/[^A-Za-z0-9]/g, '');
    setMask(numericValue.length > 4 && /^[A-Z]{3}\d[A-Z]/i.test(numericValue) ? 'aaa-9a99' : 'aaa-9999');
  }, [value]);

  const handleChange = (e) => {
    const inputValue = e.target.value.toUpperCase();
    setValue(name, inputValue);
  };

  const handleKeyDown = (e) => {
    const digit = e.key.replace(/[^A-Za-z0-9]/g, '');
    const currentValue = e.target.value.replace(/[^A-Za-z0-9]/g, '');
    const size = currentValue.concat(digit).length;

    setMask(size > 4 && /^[A-Z]{3}\d[A-Z]/i.test(currentValue.concat(digit)) ? 'aaa-9a99' : 'aaa-9999');
  };

  return (
    <Form.Group controlId={name} className="mb-3">
      {label && <Form.Label className="mb-1">{label}</Form.Label>}
      <InputMask
        mask={mask}
        maskChar={null}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        readOnly={userRoles}
        autoComplete='off'
        {...register(name, {
          ...rules,
          validate: (inputValue) => {
            const valueWithoutMask = inputValue.replace(/[^A-Za-z0-9]/g, '');
            const isOldModel = /^[A-Z]{3}\d{4}$/i.test(valueWithoutMask);
            const isNewModel = /^[A-Z]{3}\d[A-Z]\d{2}$/i.test(valueWithoutMask);
            if (isOldModel || isNewModel || !valueWithoutMask) {
              return true;
            }
            return 'Placa inválida.';
          },
        })}
      >
        {(inputProps) => (
          <Form.Control
            readOnly={userRoles}
            {...inputProps}
            onInput={(e) => {
              e.target.value = e.target.value.toUpperCase();
            }}
            className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
          />
        )}
      </InputMask>
      {errors[name] && <Form.Control.Feedback type="invalid">{errors[name].message}</Form.Control.Feedback>}
    </Form.Group>
  );
};

export default LicensePlateInput;